export default {
        srcSet: __webpack_public_path__ + "static/media/input-field-down.5e840108.png"+" 632w",
        images: [{path: __webpack_public_path__ + "static/media/input-field-down.5e840108.png",width: 632,height: 69}],
        src: __webpack_public_path__ + "static/media/input-field-down.5e840108.png",
        toString: function(){return __webpack_public_path__ + "static/media/input-field-down.5e840108.png"},
        placeholder: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAECAMAAADLTo0SAAAAD1BMVEUAAAAEAQACAQCrUyOGQxoSu/1CAAAABXRSTlMhDBhPJsPFm0IAAAAJcEhZcwAACxMAAAsTAQCanBgAAAAZSURBVHicY2AgGjARBYgyCUIxEgTMLCASACK/AHwSTB9nAAAAAElFTkSuQmCC",
        width: 632,
        height: 69
      }